import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { ValidatorsService } from 'src/app/services/validators.service';
import { LOWERCASE_REGEX, PASSWORD_REGEX, SPECIAL_CHARACTERS_REGEX, UPPERCASE_REGEX, VALIDATION_RULES } from 'src/app/shared/data/data';
import { RequestStatus } from 'src/app/shared/data/models';
import { SubSink } from 'subsink';


@Component({
  selector: 'app-psw-change-modal',
  templateUrl: './psw-change-modal.component.html',
  styleUrls: ['./psw-change-modal.component.scss']
})
export class PswChangeModalComponent implements OnInit, OnDestroy {

  private subs = new SubSink();
  public hide: boolean = true;
  public rules: any = VALIDATION_RULES;
  public statusDetail: RequestStatus = 'init';
  public urlTree: any;
  public recoveryToken: any;
  public hideRequiredControl = new FormControl(true);
  private emailUser: string | null = null;
  public isCurrentPassword: boolean = false;
  private userToken: string = '';
  public newPasswordValidations: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    newPassword: ['', [Validators.required, Validators.pattern(PASSWORD_REGEX)]],
    confirmPassword: ['', [Validators.required, Validators.pattern(PASSWORD_REGEX)]],
  }, {
    validators: this.validatorService.samePassword('newPassword', 'confirmPassword')
  });

  public currentPassword: FormGroup = this.fb.group({
    currentPasword: ['', [Validators.required,]]
  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private validatorService: ValidatorsService,
    public dialogRef: MatDialogRef<PswChangeModalComponent>,
    private authenticationService: AuthService
  ) {
    this.emailUser = localStorage.getItem('user') || null;
    this.inputListener();
  }
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.newPasswordValidations.controls['newPassword'].disable();
    this.newPasswordValidations.controls['confirmPassword'].disable();
  }

  public confirmPassword(currentPassword: string) {
    if (this.emailUser != null) {
      const userData = {
        email: this.emailUser,
        password: currentPassword
      }
      this.authenticationService.login(userData).subscribe({
        next: (response: any) => {
          this.statusDetail = 'success';
          this.isCurrentPassword = true;
          this.newPasswordValidations.controls['newPassword'].enable();
          this.newPasswordValidations.controls['confirmPassword'].enable();
          this.userToken = response.token;
        }, error: (err) => {
          this.statusDetail = 'error';
          this.newPasswordValidations.controls['newPassword'].disable();
          this.newPasswordValidations.controls['confirmPassword'].disable();
        }
      });
    }

  }

  get newPasswordInvalid() {
    return this.newPasswordValidations.get('newPassword')?.invalid && this.newPasswordValidations.get('newPassword')?.touched;
  };

  get newPasswordInvalid2() {
    return this.newPasswordValidations.get('newPassword')?.hasError('pattern');
  };


  get confirmPasswordInvalid() {
    const pass1 = this.newPasswordValidations.get('newPassword')?.value;
    const pass2 = this.newPasswordValidations.get('confirmPassword')?.value;
    return (pass1 === pass2) ? false : true;
  }

  public gettingValue(valueInput: string) {
    valueInput ? this.confirmPassword(valueInput) : null;
  }

  public sendNewCredencial(form: any): void {
    const body = {
      old_password: this.currentPassword.controls['currentPasword'].value,
      new_password: form.newPassword
    }


    if (this.userToken != '') {
      this.authenticationService.changePassword(body, this.userToken).subscribe({
        next: () => {
          localStorage.removeItem('token');
          this.router.navigate(['/auth/login']);
          this.dialogRef.close();
        }, error: () => { }
      });
    }
  }

  public closeModalPasswordChange(): void {
    this.dialogRef.close();
  }

  public inputListener(): void {
    this.subs.sink = this.newPasswordValidations.controls['newPassword'].valueChanges.subscribe((value: any) => {
      this.rules.forEach((item: any, index: number) => {
        switch (index) {
          case 0:
            this.rules[index].value = value.length >= 8;
            break;
          case 1:
            this.rules[index].value = UPPERCASE_REGEX.test(value);
            break;
          case 2:
            this.rules[index].value = LOWERCASE_REGEX.test(value);
            break;
          case 3:
            this.rules[index].value = SPECIAL_CHARACTERS_REGEX.test(value);
            break;
        }
      });
    });

  }
}
